import React from "react";
import { Route, Routes } from "react-router-dom";
import ModeratorDashboard from "./ModeratorDashboard";
import ModeratorAnswerView from "./ModeratorAnswerView";
import ModeratedAnswersHistory from "./ModeratedAnswersHistory";

export const ModeratorRoutes = () => {
  return (
    <Routes>
      <Route path="/dashboard" element={<ModeratorDashboard />} />
      <Route path="/answer/:answerId" element={<ModeratorAnswerView />} />
      <Route path="/history" element={<ModeratedAnswersHistory />} />
    </Routes>
  );
};
